'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002489 from "./presto.types$$anon$89.js";
import * as $j_presto$002etypes$0024$002dRule from "./presto.types$-Rule.js";
import * as $j_presto$002etypes$0024$002dRule$0024$0024anon$0024102 from "./presto.types$-Rule$$anon$102.js";
import * as $j_presto$002etypes$0024$002dRule$0024$0024anon$002490 from "./presto.types$-Rule$$anon$90.js";
import * as $j_presto$002etypes$0024$002dRule$0024$0024anon$002492 from "./presto.types$-Rule$$anon$92.js";
import * as $j_presto$002etypes$0024$002dRule$0024$0024anon$002494 from "./presto.types$-Rule$$anon$94.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
function $p_Lpresto_types$Rule$__decode$1__Lio_circe_HCursor__Lpresto_types$RuleKind__s_util_Either($thiz, c$1, kind) {
  var x = $j_presto$002etypes$0024$002dRule$002dKind$0024.$s_Lpresto_types$RuleKind$__Allow__Lpresto_types$RuleKind();
  if ((x === kind)) {
    return $thiz.cIF().F(c$1);
  }
  var x$3 = $j_presto$002etypes$0024$002dRule$002dKind$0024.$s_Lpresto_types$RuleKind$__Ip__Lpresto_types$RuleKind();
  if ((x$3 === kind)) {
    return $thiz.cIM().F(c$1);
  }
  var x$5 = $j_presto$002etypes$0024$002dRule$002dKind$0024.$s_Lpresto_types$RuleKind$__TimeRange__Lpresto_types$RuleKind();
  if ((x$5 === kind)) {
    return $thiz.cIS().F(c$1);
  }
  var x$7 = $j_presto$002etypes$0024$002dRule$002dKind$0024.$s_Lpresto_types$RuleKind$__DaysInWeek__Lpresto_types$RuleKind();
  if ((x$7 === kind)) {
    return $thiz.cIU().F(c$1);
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(kind);
}
export { $p_Lpresto_types$Rule$__decode$1__Lio_circe_HCursor__Lpresto_types$RuleKind__s_util_Either as $p_Lpresto_types$Rule$__decode$1__Lio_circe_HCursor__Lpresto_types$RuleKind__s_util_Either };
/** @constructor */
function $c_Lpresto_types$Rule$() {
  this.cab = null;
  this.cae = false;
  this.ca7 = null;
  this.ca8 = false;
  this.ca9 = null;
  this.caa = false;
  this.caf = null;
  this.cag = false;
  this.cah = null;
  this.cai = false;
  this.cac = null;
  this.cad = false;
}
export { $c_Lpresto_types$Rule$ as $c_Lpresto_types$Rule$ };
$p = $c_Lpresto_types$Rule$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$;
/** @constructor */
function $h_Lpresto_types$Rule$() {
}
export { $h_Lpresto_types$Rule$ as $h_Lpresto_types$Rule$ };
$h_Lpresto_types$Rule$.prototype = $p;
$p.pe = (function() {
  if ((!this.cae)) {
    this.cab = new $c_Lpresto_types$Rule$$anon$88(this);
    this.cae = true;
  }
  return this.cab;
});
$p.cIF = (function() {
  if ((!this.ca8)) {
    this.ca7 = new $j_presto$002etypes$0024$002dRule$0024$0024anon$002490.$c_Lpresto_types$Rule$$anon$90(this);
    this.ca8 = true;
  }
  return this.ca7;
});
$p.cIM = (function() {
  if ((!this.caa)) {
    this.ca9 = new $j_presto$002etypes$0024$002dRule$0024$0024anon$002492.$c_Lpresto_types$Rule$$anon$92(this);
    this.caa = true;
  }
  return this.ca9;
});
$p.cIS = (function() {
  if ((!this.cag)) {
    this.caf = new $j_presto$002etypes$0024$002dRule$0024$0024anon$002494.$c_Lpresto_types$Rule$$anon$94(this);
    this.cag = true;
  }
  return this.caf;
});
$p.cIU = (function() {
  if ((!this.cai)) {
    this.cah = new $j_presto$002etypes$0024$002dRule$0024$0024anon$0024102.$c_Lpresto_types$Rule$$anon$102(this);
    this.cai = true;
  }
  return this.cah;
});
$p.cIO = (function() {
  if ((!this.cad)) {
    this.cac = new $c_Lpresto_types$Rule$$anon$104(this);
    this.cad = true;
  }
  return this.cac;
});
$p.cHy = (function(x$0) {
  return new $j_presto$002etypes$0024$002dRule.$c_Lpresto_types$Rule($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(1)), x$0.j(2), x$0.j(3), x$0.j(4), x$0.j(5), x$0.j(6));
});
var $d_Lpresto_types$Rule$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$, "presto.types$Rule$", ({
  a1h: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$Rule$ as $d_Lpresto_types$Rule$ };
var $n_Lpresto_types$Rule$;
function $m_Lpresto_types$Rule$() {
  if ((!$n_Lpresto_types$Rule$)) {
    $n_Lpresto_types$Rule$ = new $c_Lpresto_types$Rule$();
  }
  return $n_Lpresto_types$Rule$;
}
export { $m_Lpresto_types$Rule$ as $m_Lpresto_types$Rule$ };
/** @constructor */
function $c_Lpresto_types$Rule$$anon$104(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$Rule$$anon$104 as $c_Lpresto_types$Rule$$anon$104 };
$p = $c_Lpresto_types$Rule$$anon$104.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$104;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$104() {
}
export { $h_Lpresto_types$Rule$$anon$104 as $h_Lpresto_types$Rule$$anon$104 };
$h_Lpresto_types$Rule$$anon$104.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.G = (function(c) {
  var this$1 = $m_Lpresto_types$Rule$();
  var this$2 = c.cIc("kind", $j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().Tk());
  if ((this$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Right)) {
    var b = this$2.bZ;
    var this$3 = $p_Lpresto_types$Rule$__decode$1__Lio_circe_HCursor__Lpresto_types$RuleKind__s_util_Either(this$1, c, b);
    return ((this$3 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Right) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Right(this$3.bZ) : this$3);
  } else {
    return this$2;
  }
});
var $d_Lpresto_types$Rule$$anon$104 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$104, "presto.types$Rule$$anon$104", ({
  a1j: 1,
  a: 1,
  f: 1
}));
export { $d_Lpresto_types$Rule$$anon$104 as $d_Lpresto_types$Rule$$anon$104 };
/** @constructor */
function $c_Lpresto_types$Rule$$anon$88(outer) {
  this.caF = null;
  this.cax = null;
  this.cay = false;
  this.caG = null;
  this.caH = false;
  this.caK = null;
  this.caD = null;
  this.caE = false;
  this.caz = null;
  this.caA = false;
  this.caB = null;
  this.caC = false;
  this.caI = false;
  this.caJ = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.caF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.caK = "Rule";
}
export { $c_Lpresto_types$Rule$$anon$88 as $c_Lpresto_types$Rule$$anon$88 };
$p = $c_Lpresto_types$Rule$$anon$88.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$88;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$88() {
}
export { $h_Lpresto_types$Rule$$anon$88 as $h_Lpresto_types$Rule$$anon$88 };
$h_Lpresto_types$Rule$$anon$88.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.caF;
});
$p.M = (function() {
  if ((!this.cay)) {
    this.cax = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.cay = true;
  }
  return this.cax;
});
$p.O = (function() {
  if ((!this.caH)) {
    this.caG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.caH = true;
  }
  return this.caG;
});
$p.D = (function() {
  return this.caK;
});
$p.t = (function() {
  if ((!this.caE)) {
    this.caD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("description", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("payload", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))));
    this.caE = true;
  }
  return this.caD;
});
$p.N = (function() {
  if ((!this.caA)) {
    this.caz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($m_Lpresto_types$Rule$().cIO(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))));
    this.caA = true;
  }
  return this.caz;
});
$p.Q = (function() {
  if ((!this.caC)) {
    this.caB = new $j_presto$002etypes$0024$0024anon$002489.$c_Lpresto_types$$anon$89();
    this.caC = true;
  }
  return this.caB;
});
$p.v = (function() {
  if ((!this.caJ)) {
    this.caI = false;
    this.caJ = true;
  }
  return this.caI;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee82) => ((p) => \u03b4scrutinee82.cHy(p)))($m_Lpresto_types$Rule$())));
});
var $d_Lpresto_types$Rule$$anon$88 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$88, "presto.types$Rule$$anon$88", ({
  a1k: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$88 as $d_Lpresto_types$Rule$$anon$88 };
//# sourceMappingURL=presto.types$-Rule$.js.map
